<template>
  <div id="cashback-app">
    <div class="divide-y divide-gray-200 rounded-lg bg-white shadow">
      <div class="px-4 py-5 sm:px-6">
        <DepotSelect></DepotSelect>
      </div>
      <div class="px-4 py-5 sm:p-6">
        <FondsSelect></FondsSelect>
        <FondsDisplay></FondsDisplay>
        <ChartRow></ChartRow>
        <div :class="[fondsStore.notTradable ? 'opacity-40' : '']">
          <ResultsRow></ResultsRow>
        </div>
      </div>
      <div class="px-4 py-4 sm:px-6">
        <p class="text-xs text-gray-500">
          Angaben basieren auf Original-Courtagelisten unserer Partnerbanken; alle Angaben ohne Gewähr
        </p>
        <p class="text-xs text-gray-500" v-if="fondsStore.selectedFonds !== null">
          <strong>**</strong> envestor Wertentwicklung bei 100% Rabatt auf den Ausgabeaufschlag, Wiederanlage der Cashbacks und einer Marktentwicklung von 6% pro Jahr.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { ref } from 'vue'
import DepotSelect from '@/components/BankSelect.vue'
import FondsSelect from '@/components/FondsSelect.vue'
import FondsDisplay from '@/components/FondsDisplay.vue'
import ChartRow from '@/components/ChartRow.vue'
import ResultsRow from '@/components/ResultsRow.vue'
import { useFondsStore } from '@/stores/fonds'
const fondsStore = useFondsStore()
// const slider1 = ref({
//   value: 50,
//   step: 5,
//   direction: 'rtl',
//   format: function (value) {
//     return `${Math.round(value)}€`
//   }
// })
</script>

<style src="@vueform/slider/themes/default.css"></style>
<style>
#cashback-app {
  margin: 0 auto;
  margin-top: 30px;
}
</style>
